<template>
    <div class="Button" :touch-action="disabled ? undefined : 'auto'" :class="modifierClass" @click="onClick">
        <slot />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from 'vue-property-decorator';

    @Component({
        emits: [ 'click' ],
        // PRODUCT-26110 Task 10 (INSTANCE_LISTENERS): `onClick` conditionally
        // suppresses the re-emitted `click` while `disabled` -- it can't simply be
        // deleted (unlike EidIcon's unconditional re-emit). Vue 3 merges listeners
        // into `$attrs`, so without `inheritAttrs: false` a caller's `@click` would now
        // ALSO auto-fall-through onto this root `<div>` as a second, unconditional
        // native listener, both double-firing the handler and bypassing the disabled
        // gate. `class`/`style`/`touch-action` are own bindings, unaffected; the
        // `loading`/`icon` attrs a couple of call sites pass are undeclared, unused
        // by this component (no matching prop, no `[loading]`/`[icon]` CSS selector
        // anywhere), and harmless to stop forwarding.
        inheritAttrs: false,
    })
    export default class Button extends Vue {
        @Prop({ type: Boolean, default: false })
        private disabled!: boolean;

        @Prop({ type: Object, default: () => ({}) })
        private flags!: { [key: string]: boolean };

        @Prop({ type: String, default: undefined })
        private type!: string | undefined;

        private get modifierClass() {
            const flags = Object.keys(this.flags).filter((flag) => this.flags[flag]);
            const parts = [ this.disabled ? 'disabled' : '', this.type, ...flags ].filter(Boolean);
            return parts.length ? `Button--${parts.join('-')}` : null;
        }

        private onClick(event: MouseEvent) {
            if (!this.disabled) {
                this.$emit('click', event);
            }
        }
    }
</script>
